<ng-container *ngIf="asOfDate; else loading">
	<section class="padding-bottom-32"><span dcrHTMLKey="ESG_AS_OF">As of</span> {{ asOfDate }}</section>

	<ng-container *ngIf="validEsgData; else errorTemplate">
		<div class="text-28 text-bold padding-bottom-32" dcrHTMLKey="ESG_METRICS_HEADER">ESG Metrics</div>
		<div class="dz-grid padding-0">
			<div class="dz-row padding-bottom-32">
				<div class="dz-col-lg-16 dz-col-md-24">
					<div dcrHTMLKey="ESG_METRICS_DESC">
						We quantify the ESG characteristics of the model portfolio by comparing its MSCI ESG Ratings and Carbon Emissions with a non-ESG Benchmark portfolio. The
						Non-ESG Benchmark portfolio refers to a portfolio that uses traditional non-ESG market indices as building blocks. The following charts show the ESG Uplift
						and Carbon Reduction obtained from investing in the model portfolio relative to a traditional non-ESG Benchmark.
					</div>
				</div>
			</div>
		</div>

		<ng-template [componentId]="{ componentId: 'me.esg.uplift', ids: familyIds$ }" let-data [error]="errorTemplate">
			<mb-esg-uplift [data]="data"></mb-esg-uplift>
		</ng-template>

		<div class="dz-grid margin-top-40 padding-left-0 padding-right-0">
			<div class="dz-row data-row d-flex align-items-center header">
				<div class="dz-col-12"><mb-esg-rating-mapping-table></mb-esg-rating-mapping-table></div>
				<div class="dz-col-12"></div>
			</div>
		</div>

		<section class="esg-carbon-emission">
			<div class="padding-top-50">
				<div class="text-20 text-bold" dcrHTMLKey="LOW_CARBON_FOOTPRINT_TITLE">LOW CARBON FOOTPRINT</div>
				<div class="dz-grid padding-0">
					<div class="dz-row">
						<div class="dz-col-lg-16 dz-col-md-24">
							<div dcrHTMLKey="LOW_CARBON_FOOTPRINT_SUBTITLE" class="padding-top-30">
								The following metrics illustrates the annual carbon emission reduction obtained by investing one million USD in the ESG models relative to a non-ESG
								comparative benchmark (based on MSCI ESG Research analysis of portfolio companies' carbon emissions.
							</div>
						</div>
					</div>
				</div>
			</div>
			<ng-template [componentId]="{ componentId: 'me.esg.carbon.intensity', ids: familyIds$ }" let-res [error]="errorTemplate">
				<div class="row">
					<div class="col-24">
						<esg-carbon-emissions-impact *ngIf="res" [data]="res?.tab?.['esg.carbonIntensity']"> </esg-carbon-emissions-impact>
					</div>
				</div>
			</ng-template>
		</section>
	</ng-container>
</ng-container>

<ng-template #loading>
	<mb-esg-uplift-skeleton></mb-esg-uplift-skeleton>
</ng-template>

<ng-template #errorTemplate>
	<div class="margin-object-3 margin-object-0-sm" dcrHTMLKey="ESG_DATA_ERROR">The esg data is currently not available for this model family</div>
</ng-template>
